import { Reducer } from "redux";
import { isEmpty } from "lodash";

import { GetNPPESDataActionDispatchTypes, nppesInitialRecord } from "../constants/PhysicianDetails";
import { NPPESDataResponse } from "../models/api/PhysicianDetails";
import { ReferralIntakePhysicianDetailsDispatchTypes } from "../models/dispatchTypes/PhysicianDetails";

const initialState: NPPESDataResponse = {
  loading: true,
  response: nppesInitialRecord
};

const NppesDetailsDataReducer: Reducer<
NPPESDataResponse,
  ReferralIntakePhysicianDetailsDispatchTypes
> = (state = initialState, action) => {
  switch (action.type) {
    case GetNPPESDataActionDispatchTypes.GET_NPPES_DATA_INVOKE: {
      return {
        ...state,
        loading: true,
      };
    }
    case GetNPPESDataActionDispatchTypes.GET_NPPES_DATA_SUCCESS: {
      return {
        ...state,
        response: isEmpty(action.response) ? nppesInitialRecord : action.response,
        loading: false,
      };
    }
    case GetNPPESDataActionDispatchTypes.GET_NPPES_DATA_RESET: {
      return initialState;
    }
  }
  return state;
};

export default NppesDetailsDataReducer;
